import React from "react";
import "../style/skills.css";

const Skills = () => {
  return (
    <div>
      <div className="container-skills">
        <div data-aos="flip-left" className="wrapper-skill">
          <i className="fas fa-laptop-code"></i>
          <h3 className="skills-heading">Frontend</h3>
          <div className="skills">
            <p>
              <i className="fas fa-check"></i> HTML5
            </p>
            <p>
              <i className="fas fa-check"></i> CSS3
            </p>
            <p>
              <i className="fas fa-check"></i> JAVASCRIPT
            </p>
            <p>
              <i className="fas fa-check"></i> REACT.JS
            </p>
            <p>
              <i className="fas fa-check"></i> BOOTSTRAP 4
            </p>
          </div>
        </div>
        <div
          data-aos="flip-left"
          data-aos-delay="400"
          className="wrapper-skill"
        >
          <i className="fas fa-database"></i>
          <h3 className="skills-heading">Backend</h3>
          <div className="skills">
            <p>
              <i className="fas fa-check"></i> MONGODB
            </p>
            <p>
              <i className="fas fa-check"></i> NODE.JS
            </p>
            <p>
              <i className="fas fa-check"></i> PHP8
            </p>
            <p>
              <i className="fas fa-check"></i> MYSQL
            </p>
            <p>
              <i className="fas fa-check"></i> STRAPI 
            </p>
          </div>
        </div>
        <div
          data-aos="flip-right"
          data-aos-delay="900"
          className="wrapper-skill"
        >
          <i className="fas fa-pencil-ruler"></i>
          <h3 className="skills-heading">Otros</h3>
          <div className="skills">
            <p>
              <i className="fas fa-check"></i> GIT/GITHUB
            </p>
            <p>
              <i className="fas fa-check"></i> FIGMA
            </p>
            <p>
              <i className="fas fa-check"></i> ADOBE PHOTOSHOP CC
            </p>
            <p>
              <i className="fas fa-check"></i> ADOBE ILLUSTRADOR CC
            </p>
            <p>
              <i className="fas fa-check"></i> ADOBE AFTER EFFECTS
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
